import React from 'react';
import './Crusade.scss';
import { Link, useParams } from 'react-router-dom';

export default function CrusadeBtn(){
  const { cityName, communityName, propertyName } = useParams();
  return (
    <>
      <Link to={`/${cityName}/${communityName}/${propertyName}`} className="crusade-btn">
        <img src="/static/close_btn.svg" alt="" />
      </Link>
    </>
  );
};
